import { render, staticRenderFns } from "./inner.vue?vue&type=template&id=2dc1b8d6&scoped=true&"
import script from "./inner.vue?vue&type=script&lang=js&"
export * from "./inner.vue?vue&type=script&lang=js&"
import style0 from "./inner.vue?vue&type=style&index=0&id=2dc1b8d6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1b8d6",
  null
  
)

export default component.exports